import { graphql } from "babel-plugin-relay/macro";
import { fetchQuery } from "relay-hooks";
import RelayModernEnvironment from "relay-runtime/lib/store/RelayModernEnvironment";
import {
  fetchTtsLineByLineQuery,
  fetchTtsLineByLineQuery$data,
  fetchTtsLineByLineQuery$variables
} from "./__generated__/fetchTtsLineByLineQuery.graphql";

export const ttsLineByLineQl = graphql`
  query fetchTtsLineByLineQuery($text: String!, $targetLang: String!, $evenLineLang: String) {
    ttsLineByLine(text: $text, targetLang: $targetLang, evenLineLang: $evenLineLang) {
      id
      speech
    }
  }
`;

export const fetchTtsLineByLine = (environment: RelayModernEnvironment, args: fetchTtsLineByLineQuery$variables) =>
  new Promise<fetchTtsLineByLineQuery$data["ttsLineByLine"] | null>(async (done) => {
    fetchQuery<fetchTtsLineByLineQuery>(environment, ttsLineByLineQl, {
      ...args
    }).subscribe({
      next: (data) => done(data?.ttsLineByLine)
    });
  });
